export default __webpack_public_path__ + "static/media/alert-icon-10.c7f8d03c.svg";